import { afterNextRender, Component, ElementRef, input, output, viewChild } from '@angular/core';
import { TranslatePipe } from '@cmi/addin-core';

/** Stands in the tree for the planned folder, which has no guid before it is created. */
export const PLANNED_FOLDER_GUID = 'planned-folder';

/** A folder being named below parentGuid, the dossier guid standing for the root. */
export interface NewFolderDraft {
  parentGuid: string;
  title: string;
}

/** A new folder taken from the form, created only once a mail is filed into it. */
export interface PlannedFolder {
  parentGuid: string;
  titel: string;
}

/** Asks for the title of a new folder, in place where it will appear in the tree. */
@Component({
  selector: 'cmi-new-folder-form',
  imports: [TranslatePipe],
  templateUrl: './new-folder-form.html'
})
export class NewFolderForm {
  public readonly draft = input.required<NewFolderDraft>();
  public readonly titleChange = output<string>();
  public readonly add = output<void>();
  public readonly discard = output<void>();

  private readonly _input = viewChild.required<ElementRef<HTMLInputElement>>('titleInput');

  public constructor() {
    afterNextRender(() => this._input().nativeElement.focus());
  }

  protected onSubmit(event: Event): void {
    event.preventDefault();

    if (this.draft().title.trim()) {
      this.add.emit();
    }
  }
}
